/***
 * Created on 2023/8/1
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import {useBoundedStore} from '../lib/store';


function GlobalAlert(props) {
    const store = useBoundedStore();

    return (
        <div className={`global-alert ${store.globalAlert.show ? '' : 'hide'}`}>
            <div className="comp-dropdown-alert">
                <div className={`alert-content alert-content--${store.globalAlert.status} show-alert`}>
                    <div className="alert-content__text">{store.globalAlert.message}</div>
                    <div className="alert-content__btn-close cursor-pointer" onClick={() => store.globalAlert.setShow(false)}/>
                </div>
            </div>
        </div>
    );
}

export default GlobalAlert;